// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tags__PLBlHZEugn{flex-wrap:nowrap}@media(min-width: 768px){.tags__PLBlHZEugn{flex-wrap:wrap}}.tag__kvCTcXCUlm{max-width:110px}`, "",{"version":3,"sources":["webpack://./src/components/conversation/conversationTags/conversationTags.module.scss"],"names":[],"mappings":"AAEA,kBACE,gBAAA,CAEA,yBAHF,kBAII,cAAA,CAAA,CAIJ,iBACE,eAAA","sourcesContent":["@use 'common' as *;\n\n.tags {\n  flex-wrap: nowrap;\n\n  @media (min-width: $breakpoint-md) {\n    flex-wrap: wrap;\n  }\n}\n\n.tag {\n  max-width: 110px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tags": `tags__PLBlHZEugn`,
	"tag": `tag__kvCTcXCUlm`
};
export default ___CSS_LOADER_EXPORT___;
